import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import { REDIRECT_URI, APPID } from './config/index'
import { getQueryString, isPc } from './util/index'
import Notify from 'vant/lib/notify'
// import wx  from  './util/wx'
// import './monitor'
import exifr from 'exifr'
import {
  Dialog,
  Field,
  Button,
  Popup,
  DatetimePicker,
  Picker,
  NumberKeyboard,
  Form,
  Cell,
  CellGroup,
  List,
  NoticeBar,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Empty,
  Area,
  Overlay,
  Uploader,
  Loading
} from 'vant'
import 'vant/lib/index.css'
// import { getData } from './api/login'
import VueCanvasPoster from 'vue-canvas-poster'
import VConsole from 'vconsole'
if (process.env.NODE_ENV === 'development') {
  Vue.use(new VConsole())
}
Vue.use(VueCanvasPoster)
Vue.use(Notify)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Button)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(NumberKeyboard)
Vue.use(Form)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(NoticeBar)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Empty)
Vue.use(Area)
Vue.use(Overlay)
Vue.use(Uploader)
Vue.use(Loading)
Vue.config.productionTip = false
Vue.prototype.$exifr = exifr
Vue.config.ignoredElements = ['wx-open-launch-weapp']
const t_id = getQueryString('t_id', 'hash')
const q_id = getQueryString('qid', 'hash')
if (t_id) {
  store.commit('setShareInfo', { t_id, q_id })
}
router.beforeEach(async (to, from, next) => {
  if (isPc() && process.env.NODE_ENV === 'production') {
    Dialog.alert({
      title: '提示',
      message: '请使用手机版微信，关注公众号后进行答题'
    })
    return false
  }
  // 动态修改标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.noCheck) {
    next()
  } else {
    // 测试环境修改用户信息
    if (location.hostname.indexOf(process.env.VUE_APP_HOSTNAME) === 0) {
      store.commit('setUserInfo', {
        editd: 1,
        phone: 1,
        subscribe: 1,
        user: {
          id: 160076,
          phone: '13700757050',
          code: null,
          profession: '普通农民',
          birthday: '2022-10-11T00:00:00.000+08:00',
          birthdayStr: null,
          sex: 1,
          sexStr: '男',
          address: '海淀区',
          integral: 0,
          star: 1,
          isOld: 0,
          status: 1,
          statusStr: '正常',
          registrationTime: '2022-10-11T14:39:41.000+08:00',
          userName: '飞翔的企鹅',
          password: 'f82bb9180d945e0f316b739cfe079f31',
          flag: 1,
          openid: 'or8TX6dASm-6N8B0jeOCIb6_HOqs',
          headImage:
            'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLvbgsiba9RukdYdYXstuyuvtWib6d4VKO5rU3jZ5XWtCQ9N5tibibncft5b9sicKdEpcqqibDGJGLoqLug/132',
          diploma: '本科',
          types: null,
          qanum: null,
          qnum: 0,
          qpnum: null,
          qrate: '0.00%',
          errornum: null,
          errortime: null,
          nickName: null,
          createUserNick: null,
          createUserId: null,
          accountId: null
        },
        token: '7c064fcf-a6ab-4ed8-8c4c-6662b7fd1d2d'
      })
    }
    const userInfo = store.getters.userInfo
    if (!userInfo && to.name !== 'login') {
      // 保存当前页面路径，在登录成功后前往当前页面
      localStorage.setItem('nextgo', window.location.hash)
      next('/login')
    } else {
      next()
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
